module.exports = __webpack_public_path__ + "img/stf.f911876f.png";